import InlinePdfAsync from './InlinePdfAsync';

export default InlinePdfAsync;
